define('plugin/membership/controller/MembershipController',['require','lib/controller/BaseController','plugin/membership/view/MembershipIndexView','plugin/membership/model/MembershipPaymentModel','plugin/membership/collection/ClientMembershipCollection','plugin/invoice/model/InvoiceRecurringProfileModel'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var MembershipIndexView = require('plugin/membership/view/MembershipIndexView');
    var MembershipPaymentModel = require('plugin/membership/model/MembershipPaymentModel');
    var ClientMembershipCollection = require('plugin/membership/collection/ClientMembershipCollection');
    var InvoiceRecurringProfileModel = require('plugin/invoice/model/InvoiceRecurringProfileModel');

    /**
     * Membership Controller
     *
     * @class MembershipController
     */
    return BaseController.extend({

        _collection: null,
        _serviceCollection: null,
        _clientCollection: null,
        _view: null,
        _message: null,

        initialize: function () {
            this._collection = this.getOption('collection');
            this._serviceCollection = this.getOption('serviceCollection');

            BaseController.prototype.initialize.call(this);
        },

        /**
         * index action, displays list of memberships
         *
         * @param services
         */
        index: function (id, services) {
            this._view = new MembershipIndexView({
                collection: this._collection,
                serviceCollection: this._serviceCollection,
                filterData: {
                    services: services,
                    id: id
                },
                withFilter: !id,
                type: 'list',
                url: 'membership' //TODO pagination in common list?
            });

            this.getMainLayout().getContentRegion().show(this._view);

            if (this._message) {
                this._view.showErrorMessage(this._message);
                this._message = null;
            }

            this._serviceCollection.load();
            this._collection.fetch();
        },

        /**
         * Creates membership order and redirect to payment or to sign up client.
         *
         * @param id
         * @param startDate
         * @param renew
         */
        buy: function (id, startDate, renew) {
            if (!startDate) {
                startDate = new Date().getMysqlDate();
            }
            var model = new MembershipPaymentModel({
                plugin_membership_id: id,
                start_date: startDate
            });
            model.save(null, {
                success: _.bind(function (model) {
                    if (model.get('invoice')) {
                        this._redirectWithReplace('invoice/pay/' + model.get('invoice').get('id'));
                    } else {
                        this._redirectWithReplace('membership/my/status/' + model.get('status'));
                    }
                }, this),
                error: _.bind(function (model, xhr) {
                    var result = xhr.responseJSON;
                    if (result && result.login_client) {
                        this._redirectWithReplace('client/sign-in/back/' + encodeURIComponent('membership/buy/' + id + '/' + startDate));
                    } else {
                        this.showErrorMessage(result.error);
                    }
                }, this)
            });
        },

        /**
         * Creates membership order with renew subscription and redirect to payment or to sign up client.
         *
         * @param id
         */
        renew: function (id, startDate) {
            this.buy(id, startDate, true);
        },

        /**
         * Displays clients memberships info
         *
         * @param status
         * @param id
         */
        my: function (status, id, page) { 
            this._clientCollection = new ClientMembershipCollection();
            this._clientCollection.getPager().setPage(page || 1);

            this._view = new MembershipIndexView({
                collection: this._clientCollection,
                serviceCollection: this._serviceCollection,
                type: 'client',
                status_str: status,
                highlighted: id,
                url: 'membership/my/page/:page'
            });

            this.listenTo(this._view, 'onCancel', this.cancelMembership);

            this.getMainLayout().getContentRegion().show(this._view);

            this.listenTo(this._clientCollection, 'error', this.handleClientsMembershipError);

            this._serviceCollection.load();

            // this._clientCollection.fetch(); //NB will be called automatically by pager
        },

        myHighlight: function (id) {
            this.my(null, id);
        },
        
        myPaginated: function (page, id) {
            this.my(null, id, page)
        },

        /**
         * Handles clients membership load error
         *
         * @param collection
         * @param xhr
         */
        handleClientsMembershipError: function (collection, xhr) {
            if (xhr.responseJSON && xhr.responseJSON.login_client) {
                this._redirect('client/sign-in/back/' + encodeURIComponent('membership/my'));
            }
        },
        
        /**
         * Shows error message
         *
         * @param String error
         */
        showErrorMessage: function (error) {
            if (this._view && !this._view.isDestroyed) {
                this._view.showErrorMessage(error);
            } else {
                this._message = error;

                this._redirect('membership');
            }
        },
        
        /**
         * Cancels membership
         *
         * @param model
         */
        cancelMembership: function (model) {
            var profileModel = new InvoiceRecurringProfileModel({
                id: model.get('recurring_profile_id')
            });
            profileModel.destroy({
                success: _.bind(function () {
                    this._view.refreshCollection()
                }, this)
            });
        }

    });

});
